import React, { ReactNode } from 'react'

import { DataProviderProvider } from '@/shared/contexts'
import { api } from '@/shared/lib/api'
import errorMessagesTrans from '@/shared/lib/errors/translations/api.json'

export const DataProvider = ({ children }) => {
  return (
    <DataProviderProvider
      httpClient={api}
      errorMessagesTrans={errorMessagesTrans}
    >
      {children}
    </DataProviderProvider>
  )
}
